import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Libraries20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.8674 2.7686C15.6611 2.09789 14.9431 1.72844 14.2774 1.95035L11.1437 2.99491C10.9497 2.55615 10.5106 2.25 10 2.25H6.5C6.32222 2.25 6.15312 2.28711 6 2.35401C5.84688 2.28711 5.67778 2.25 5.5 2.25H2C1.30964 2.25 0.75 2.80964 0.75 3.5V16.5C0.75 17.1904 1.30964 17.75 2 17.75H5.5C5.67778 17.75 5.84689 17.7129 6 17.646C6.15312 17.7129 6.32222 17.75 6.5 17.75H10C10.6904 17.75 11.25 17.1904 11.25 16.5V8.98751L13.6328 16.7315C13.8391 17.4022 14.557 17.7716 15.2228 17.5497L18.7738 16.366C19.418 16.1513 19.773 15.4616 19.5733 14.8126L15.8674 2.7686ZM11.4324 4.47982L14.509 3.45429L18.0678 15.0202L14.9912 16.0458L11.4324 4.47982ZM6.75 16.25V3.75H9.75V16.25H6.75ZM2.25 3.75H5.25V16.25H2.25V3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Libraries20.displayName = 'Libraries20';
export default Libraries20;
